<template>
  <svg class="svg-search" width="25" height="25" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg" v-show="show">
    <circle cx="10.2" cy="10.2" r="9.2" stroke="#A7A5A6" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M17.0996 17.1L23.9996 24" stroke="#A7A5A6" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
  </svg>
</template>
  
<script>
  export default {
    name: 'SvgSearch', 
    props: {
      show: Boolean
    },
  }
</script>